module.exports = __webpack_public_path__ + "static/blue-orange.d93d72ee.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/financing/blue-orange.png
// module id = 184
// module chunks = 2